import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { cn } from "@/modules/lib/utils"

type Props = {
  className?: string
} & React.ComponentProps<"div">

export function MemberOffersWrapperSkeleton({ className, ...props }: Props) {
  return (
    <div className={cn("flex w-full flex-col gap-4", className)} {...props}>
      <div className="flex w-full gap-2">
        <Skeleton className="flex h-9 w-44 rounded-full" />
        <Skeleton className="flex h-9 w-28 rounded-full" />
        <Skeleton className="flex h-9 w-36 rounded-full" />
      </div>
      <div className="flex w-full flex-col gap-4">
        <Skeleton className="flex h-18 rounded-3xl" />
        <Skeleton className="flex h-18 rounded-3xl" />
        <Skeleton className="flex h-18 rounded-3xl" />
      </div>
    </div>
  )
}
